import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const ExactRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--exact']}>
    <Route index element={<Index />} />
  </SubRouter>
))
